module.exports = __webpack_public_path__ + "img/drop-down.ca516e59.svg";